"use client";
import Link from "next/link";
import Image from "next/image";
import { BlogPost } from "@/lib/contentful/blog";
import CTA from "@/components/ui/CTA";

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

interface BlogPostProps {
  post: BlogPost;
  isFeatured?: boolean;
}

export default function BlogPostCard({
  post,
  isFeatured = false,
}: BlogPostProps) {
  return (
    <div>
      <Link href={`/blog/${post.slug}`} className="block">
        <div className="relative aspect-[32/9] w-full lg:rounded-xl overflow-hidden">
          <Image
            src={post.coverImage.url}
            alt={post.title}
            fill
            className="object-cover"
            priority={isFeatured}
          />
        </div>
      </Link>

      <div className={`mt-6 ${isFeatured ? "max-w-5xl mx-auto" : ""}`}>
        <div className="text-text-muted-light dark:text-text-muted-dark">
          {formatDate(post.publishedDate)}
        </div>

        <Link href={`/blog/${post.slug}`}>
          <h2
            className={`${isFeatured ? "text-4xl md:text-5xl" : "text-2xl"} font-medium mt-2 mb-3 hover:text-gray-light dark:hover:text-gray-dark transition-colors`}
          >
            {post.title}
          </h2>
        </Link>

        <p
          className={`${isFeatured ? "text-xl md:text-2xl" : ""} text-text-muted-light dark:text-text-muted-dark`}
        >
          {post.synopsis}
        </p>

        <div className="mt-4">
          <CTA href={`/blog/${post.slug}`}>Read post</CTA>
        </div>
      </div>
    </div>
  );
}
